// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const SocialMessenger = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g transform="translate(1 1)" fill="none" fillRule="evenodd">
			<circle stroke="#208AFF" cx={20} cy={20} r={20} />
			<path
				d="m21.28 21.57-1.968-2.104-3.8 2.036 4.072-4.344 1.968 1.969 3.8-2.037-4.071 4.48zM20.5 12c-4.142 0-7.5 3.176-7.5 7.093 0 2.197 1.056 4.16 2.715 5.461v2.65l2.553-1.338c.705.208 1.455.32 2.232.32 4.142 0 7.5-3.176 7.5-7.093S24.642 12 20.5 12z"
				fill="#208AFF"
			/>
		</g>
	</svg>
);
export default SocialMessenger;
